<template>
        <div class="text-center mb-2">
            <h4 class="m-0">Attacks</h4>
        </div>

        <!-- Character abilities -->
        <div v-for="attack in resolvedAttacks" :key="attack.id">
            <div
                class="attack-card card bg-dark text-light mb-3"
                @click="openModal(attack)"
            >
                <!-- Card header with attack name -->
                <div
                    class="card-header d-flex justify-content-between align-items-center"
                >
                    <strong class="mb-0">{{ attack.name }}</strong>
                    <img
                        :src="getAttackImage(attack.archetype)"
                        :alt="attack.name"
                        class="rounded-3 d-none d-md-block"
                        style="max-width: 2rem; cursor: pointer"
                        @click.stop="
                            $emit('request-dice-box', attack.archetype)
                        "
                    />
                </div>

                <!-- Card body with details -->
                <div class="card-body">
                    <div class="row mb-1">
                        <div class="col-sm-12">
                            <strong>Damage:</strong>
                            {{ attack?.damage || "N/A" }}
                            {{ attack?.damageType || "" }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <strong>Range:</strong> {{ attack?.range || "N/A" }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

<div
    class="modal fade"
    id="attackModal"
    tabindex="-1"
    aria-hidden="true"
    ref="attackModal"
>
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div
            class="modal-content bg-dark text-light rounded-3 shadow-lg"
        >
            <div class="modal-header border-secondary">
                <img
                    v-if="selectedAttack"
                    :src="getAttackImage(selectedAttack.archetype)"
                    :alt="selectedAttack.archetype"
                    style="max-width: 2rem"
                    class="me-4"
                    @click="
                        $emit(
                            'request-dice-box',
                            selectedAttack.archetype
                        )
                    "
                />
                <h4 class="modal-title" v-if="selectedAttack">
                    {{ selectedAttack.name }}
                </h4>
                <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    @click="closeModal"
                ></button>
            </div>
            <div class="modal-body" v-if="selectedAttack">
                <div class="row">
                    <div class="col-sm-12 mt-3">
                        <p>{{ selectedAttack.description }}</p>
                    </div>
                    <div class="col-sm-6">
                        <strong>Damage:</strong>
                        {{ selectedAttack?.damage || "N/A" }}
                        {{ selectedAttack?.damageType || "" }}
                    </div>

                    <div class="col-sm-6">
                        <strong>Range:</strong>
                        {{ selectedAttack?.range || "N/A" }}
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-secondary"
                    data-bs-dismiss="modal"
                    @click="closeModal"
                >
                    <font-awesome-icon
                        icon="multiply"
                        class="me-1"
                    />Close
                </button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { Modal } from "bootstrap";
import { useRosterStore } from "../stores/index";

export default {
    name: "MonsterAttacks",
    props: {
        attacks: {
            type: Array,
            default: () => [],
        },
        theme: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            selectedAttack: null,
            modalInstance: null,
            character: {},
        };
    },
    methods: {
        getAttackImage(stat) {
            if (!stat || stat.toLowerCase() === "none") stat = "survivor";
            return require(`@/../public/img/${stat}${this.theme}.png`);
        },
        openModal(attack) {
            this.selectedAttack = attack;
            if (!this.modalInstance) {
                this.modalInstance = new Modal(this.$refs.attackModal);
            }
            this.modalInstance.show();
        },
        closeModal() {
            this.selectedAttack = null;
            if (this.modalInstance) this.modalInstance.hide();
        },
    },
    computed: {
        resolvedAttacks() {
            const store = useRosterStore();
            return this.attacks
                .map((name) =>
                    store.bestiaryAttacks.find((a) => a.name === name)
                )
                .filter(Boolean); // removes null if not found
        },
    },
};
</script>

<style scoped>
.attack-display {
    padding: 10px 5px;
    border: solid 2px #555;
    border-radius: 8px;
}

.attack-card {
    padding: 8px;
    /* margin-bottom: 6px; */
    cursor: pointer;
    transition: background 0.2s;
}
</style>

